import React from "react";

import { DevicesScreenVMProvider } from "@screens/DevicesScreen/DevicesScreenVM";
import DevicesScreenImpl from "@screens/DevicesScreen/DevicesScreenImpl";

const DevicesScreen = () => {
  return (
    <DevicesScreenVMProvider>
      <DevicesScreenImpl />
    </DevicesScreenVMProvider>
  );
};

export default DevicesScreen;
